import { clusterApiUrl } from "@solana/web3.js";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import {
  LedgerWalletAdapter,
  PhantomWalletAdapter,
  SolflareWalletAdapter,
  TorusWalletAdapter,
} from "@solana/wallet-adapter-wallets";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";
import { useMemo } from "react";
import "./App.css";
import AppPage from "./pages/AppPage";
import { Route, Routes } from "react-router-dom";
import AppLanding from "./pages/AppLanding";
import Landing from "./pages/Landing";
import { Box } from "@chakra-ui/react";
import Referred from "./components/Referred";
import { SpeedInsights } from "@vercel/speed-insights/react";

// import the styles
require("@solana/wallet-adapter-react-ui/styles.css");

function App() {
  /* 
  console.log(address, "hello, i am elias"); */

  const solNetwork = WalletAdapterNetwork.Mainnet;
  const endpoint = useMemo(() => clusterApiUrl(solNetwork), [solNetwork]);
  // initialise all the wallets you want to use
  const wallets = useMemo(
    () => [
      new PhantomWalletAdapter(),
      new SolflareWalletAdapter({ solNetwork }),
      new TorusWalletAdapter(),
      new LedgerWalletAdapter(),
    ],
    [solNetwork]
  );
  return (
    <>
      <SpeedInsights />
      <ConnectionProvider endpoint={endpoint}>
        <WalletProvider wallets={wallets} autoConnect={true}>
          <WalletModalProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/start" element={<AppPage />} />
              <Route path="/app" element={<AppLanding />} />
              <Route
                path="/campaign/referred-by-gotbit"
                element={<Referred />}
              />
            </Routes>
          </WalletModalProvider>
        </WalletProvider>
      </ConnectionProvider>
      {/* 
      <img
        src="https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/651ac706acdc2e20061979db_BLUE%20HUE.png"
        loading="lazy"
        sizes="100vw"
        srcset="https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/651ac706acdc2e20061979db_BLUE%20HUE-p-500.png 500w, https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/651ac706acdc2e20061979db_BLUE%20HUE-p-800.png 800w, https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/651ac706acdc2e20061979db_BLUE%20HUE-p-1080.png 1080w, https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/651ac706acdc2e20061979db_BLUE%20HUE.png 1440w"
        alt=""
        class="image-91"
      ></img> */}
      {/* <img
        src="https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/65084cdae2428c55403f8fc9_Group%2060770%20(2).png"
        loading="lazy"
        sizes="(max-width: 479px) 100vw, (max-width: 767px) 85vw, (max-width: 991px) 86vw, (max-width: 1279px) 87vw, 100vw"
        srcset="https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/65084cdae2428c55403f8fc9_Group%2060770%20(2)-p-500.png 500w, https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/65084cdae2428c55403f8fc9_Group%2060770%20(2)-p-800.png 800w, https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/65084cdae2428c55403f8fc9_Group%2060770%20(2)-p-1080.png 1080w, https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/65084cdae2428c55403f8fc9_Group%2060770%20(2)-p-1600.png 1600w, https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/65084cdae2428c55403f8fc9_Group%2060770%20(2)-p-2000.png 2000w, https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/65084cdae2428c55403f8fc9_Group%2060770%20(2)-p-2600.png 2600w, https://assets-global.website-files.com/63515aad2587c9ad3d23ae08/65084cdae2428c55403f8fc9_Group%2060770%20(2).png 3060w"
        class="image-68"
      /> */}

      {/*  <Box h="400px" bg="red">
        {" "}
        <marquee
          style={{ height: "300px" }}
          direction="up"
          behaviour="scroll"
          scrollAmount="5"
        >
          Hello, I m Elias
        </marquee>
      </Box> */}
    </>
  );
}

export default App;
